( function ( $ ) {
	class PostTeasersLoader {
		constructor(postType, classPrefix, taxonomy) {
			// Variables
			this.blockScrollLoading = true;
			this.currentPage = 1;
			this.pages = 0;
			this.postType = postType;
			this.taxonomy = taxonomy;
			this.classPrefix = classPrefix;
			this.setCurrentCategory(); // this.currentCategory

			// DOM Elements
			this.postsWrapper = $(`${this.classPrefix}-items`);
			this.loadNextButton = $(`${this.classPrefix}-load-next-button`);
			this.loadNextIcon = $(`${this.classPrefix}-load-next-icon`);
			this.loadPreviousButton = $(`${this.classPrefix}-load-previous-button`);
			this.loadPreviousIcon = $(`${this.classPrefix}-load-previous-icon`);

			// Event Listeners
			$(`${this.classPrefix}-category`).on('click', this.loadCategoryPosts.bind(this));
			$(`${this.classPrefix}-items .tease a`).on('click', (e) => {
				this.updateUrlBeforeLeaving(e, e.currentTarget);
			});
			this.loadNextButton.on('click', function() {
				this.loadNextButton.removeClass('active'); // deactivate button because infinite scroll takes over
				this.loadNextPosts();
			}.bind(this));
			this.loadPreviousButton.on('click', this.loadPreviousPosts.bind(this));

			// Scroll event for infinite scrolling
			$(document).ready(() => {
				$(window).scroll(this.onScroll.bind(this));
			});
		}

		// sets category id by selected btn
		setCurrentCategory() {
			this.currentCategory = $(`${this.classPrefix}-category.active`).data('category-id') ?? 'all';
		}

		// Update URL based on selected category and paging
		updateUrl() {
			let currentUrl = $(`${this.classPrefix}-category.active`).attr('href');

			// if no category is present, use the current url
			if (!currentUrl) {
				currentUrl = window.location.origin + '/' + window.location.pathname.split('/')[1] + '/';
			}

			const pagePath = this.currentPage > 1 ? 'page/' + this.currentPage + '/' : '';

			const newUrl = new URL(currentUrl + pagePath);
			history.replaceState({}, "", newUrl.pathname);
		}

		// Update URL before navigating to a new page, so back button on single gets to correctly paginated page
		updateUrlBeforeLeaving(e, item) {
			e.preventDefault();
			this.currentPage = parseInt($(item).parent().parent().data('page'));
			this.updateUrl();
			window.open($(item).attr('href'), '_self');
		}

		// Load more posts with options and default values
		ajaxLoadPosts = (options = {
			postType: this.postType,
			category: this.currentCategory,
			taxonomy: this.taxonomy,
			page: this.currentPage
		}) => new Promise((resolve, reject) => {
			this.blockScrollLoading = true;

			$.ajax({
				type: 'POST',
				url: IndyTheme.ajax_url,
				dataType: 'json',
				data: {
					action: 'post_teasers_loader',
					post_type: options.postType,
					category: options.category,
					taxonomy: options.taxonomy,
					page: options.page,
				},
				success: (res) => {
					const newPosts = $(res.posts);

					// adding missing event listeners to new posts
					newPosts.find('a').on('click', (e) => {
						this.updateUrlBeforeLeaving(e, e.currentTarget);
					});

					this.pages = res.pages;

					resolve(newPosts);
				},
				error: reject
			});
		});

		// load next posts with infinite scroll
		loadNextPosts() {
			this.loadNextIcon.addClass('active');

			this.currentPage = parseInt(this.postsWrapper.find('.tease:last-child').data('page'));
			this.currentPage++;

			this.ajaxLoadPosts().then(r => {
				this.postsWrapper.append(r);

				this.updateUrl();
				this.loadNextIcon.removeClass('active');

				// blocks scroll loading when there are no pages left
				this.blockScrollLoading = this.currentPage >= this.pages;
			});
		}

		// load previous posts without infinite scroll (makes no sense)
		loadPreviousPosts() {
			this.loadPreviousIcon.addClass('active');

			this.currentPage = parseInt(this.postsWrapper.find('.tease:first-child').data('page'));
			this.currentPage--;

			this.ajaxLoadPosts().then(r => {
				this.postsWrapper.prepend(r);

				this.updateUrl();
				this.loadPreviousIcon.removeClass('active');

				if (this.currentPage <= 1) {
					this.loadPreviousButton.removeClass('active');
				}
			});
		}

		// load posts by category, reset buttons and more
		loadCategoryPosts(e) {
			e.preventDefault();
			$(e.currentTarget).addClass('active')
				.siblings().removeClass('active');

			this.loadPreviousButton.removeClass('active');
			this.loadNextIcon.addClass('active');
			this.postsWrapper.empty();

			this.setCurrentCategory();
			this.currentPage = 1;

			this.ajaxLoadPosts().then(r => {
				this.postsWrapper.append(r);

				this.updateUrl();
				this.loadNextIcon.removeClass('active');

				if (this.currentPage >= this.pages) {
					this.loadNextButton.removeClass('active');
				} else {
					this.loadNextButton.addClass('active');
				}
			});
		}

		// if infinite scroll is allowed and reached bottom of page load next posts
		onScroll() {
			if (!this.blockScrollLoading &&
				$(window).scrollTop() + $(window).height() >= $(document).height() - $('.footer').outerHeight()
			) {
				this.loadNextPosts();
			}
		}
	}

	// if is an archive, init PostTeasersLoader
	const archiveItems = $('.archive-ajax-items');
	if (archiveItems.length !== 0) {
		new PostTeasersLoader(archiveItems.data('post-type'), '.archive-ajax', archiveItems.data('taxonomy'));
	}
} )( jQuery );
